class ScrollTop {
  constructor() {
    this.scrollTopBlock = document.querySelector('[data-scrolltop]');
    this.scrollTopBtn = document.querySelector('[data-scrolltop-btn]');

    if (this.scrollTopBlock || this.scrollTopBtn) {
      this.initScrollTop();
    }
  }

  onBtnClick() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  toggleScrollTopBtn() {
    if (window.pageYOffset > this.scrollTopBlock.offsetTop) {
      this.scrollTopBlock.classList.remove('hidden');
    } else {
      if (!this.scrollTopBlock.classList.contains('hidden')) {
        this.scrollTopBlock.classList.add('hidden');
      }
    }
  }

  initScrollTop() {
    window.addEventListener('scroll', this.toggleScrollTopBtn.bind(this));
    this.scrollTopBtn.addEventListener('click', this.onBtnClick.bind(this));
  }
}

export default ScrollTop;
